import { ChatMessage, Attachment, UserTimelineType, ChatMessageStatus } from './types';
import { ChatMessageType, TimelineItemType, UserBuilder, User } from '@wix/answers-api';

export class ChatMessageBuilder {
	chatMessage: ChatMessage;

	constructor () {
		this.chatMessage = {
			userId: '',
			text: '',
			chatMessageType: ChatMessageType.USER,
			creationDate: Date.now(),
			timelineItemType: TimelineItemType.CHAT_MESSAGE,
			user: new UserBuilder().build(),
			userTimelineType: UserTimelineType.REPLY,
			status: ChatMessageStatus.SUCCESS
		};
	}

	withStatus (status: ChatMessageStatus) {
		this.chatMessage.status = status;
		return this;
	}

	withText (text: string) {
		this.chatMessage.text = text;
		return this;
	}

	withChatMessageType (chatMessageType: ChatMessageType) {
		this.chatMessage.chatMessageType = chatMessageType;
		return this;
	}

	withChatMessageData (chatMessageData: {attachments: Attachment[]}) {
		this.chatMessage.chatMessageData = chatMessageData;
		return this;
	}

	withUserId (userId: string) {
		this.chatMessage.userId = userId;
		this.chatMessage.user.id = userId;
		return this;
	}

	withUser (user: User) {
		this.chatMessage.user = user;
		return this;
	}

	withCreationDate (creationDate: number) {
		this.chatMessage.creationDate = creationDate;
		return this;
	}

	build (): ChatMessage {
		return this.chatMessage;
	}
}
